'use client';

import { FC } from 'react';
import { InfoBlockStoryblok } from 'storyblok-types';
import { Container } from 'atoms/Container';
import { IconSVG } from 'atoms/IconSVG';
import { StoryBlokLink } from 'atoms/StoryBlokLink';
import { Body, Title } from 'atoms/Typography/Typography';
import { CollapseNode } from 'molecules/CollapseNode';
import { RichTextMarkdown } from '../RichText';
import styles from './styles.module.css';

export const InfoBlock: FC<{ blok: InfoBlockStoryblok }> = ({ blok }) => {
  if (!blok || blok.disableForLocale) {
    return null;
  }

  const hasAnchorLinks = blok.anchorLinks?.length > 0;

  return (
    <Container>
      <CollapseNode>
        <div className={styles.container}>
          <RichTextMarkdown
            text={blok.seoFooterIntroduction}
            components={{
              p: ({ children }) => (
                <Body type="lg" weight="medium" className={styles.text}>
                  {children}
                </Body>
              ),
            }}
          />

          {hasAnchorLinks && (
            <>
              <Title type={'md'} className={styles.title}>
                {blok.headline}
              </Title>

              <ul className={styles.list}>
                {blok.anchorLinks?.map((anchorLink) => {
                  if (!anchorLink.link) {
                    return null;
                  }

                  return (
                    <li key={anchorLink._uid} className={styles.linkItem}>
                      <StoryBlokLink
                        link={anchorLink.link}
                        className={styles.link}
                      >
                        <IconSVG
                          type="arrowLongDown"
                          className={styles.linkIcon}
                        />
                        <span className={styles.linkText}>
                          {anchorLink.text}
                        </span>
                      </StoryBlokLink>
                    </li>
                  );
                })}
              </ul>
            </>
          )}
        </div>
      </CollapseNode>
    </Container>
  );
};
